import { fetchManualCouponList } from '@/api/guest';

interface CouponInfo {}

class ManualCouponService {
  private couponList: CouponInfo[] = []; // 可用券列表

  private couponOwnerId: string; // 券所属uid

  // 获取手工券列表
  public fetchCouponList = (uid: string) => {
    return new Promise<boolean>((resolve) => {
      this.couponList = [];
      this.couponOwnerId = uid;
      if (uid) {
        fetchManualCouponList({ wyuid: uid })
          .then((res) => {
            // 未使用
            return res.data.find((category) => category.status === 0).xzCouponList;
          })
          .catch(() => {
            return null;
          })
          .then((list) => {
            if (this.couponOwnerId === uid) {
              this.couponList = list || [];
              resolve(true);
            } else {
              resolve(false);
            }
          });
      } else {
        resolve(true);
      }
    });
  };

  // 获取可用券数量
  public getAVLCount = () => {
    return this.couponList.length;
  };

  public refreshCouponList = () => {
    return this.fetchCouponList(this.couponOwnerId);
  };
}

export default ManualCouponService;
